"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = (function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
})();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _loadScript = require("load-script");
var _loadScript2 = _interopRequireDefault(_loadScript);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError(
      "this hasn't been initialised - super() hasn't been called"
    );
  }
  return call && (typeof call === "object" || typeof call === "function")
    ? call
    : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError(
      "Super expression must either be null or a function, not " +
      typeof superClass
    );
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass)
    Object.setPrototypeOf
      ? Object.setPrototypeOf(subClass, superClass)
      : (subClass.__proto__ = superClass);
}

var GOOGLE_SDK_GSI = "https://accounts.google.com/gsi/client";
var GOOGLE_SDK_API = "https://apis.google.com/js/api.js";

this.gisInited = false;
var scriptLoadingStarted = false;
var scriptLoadingStarted2 = false;
var GoogleChooser = (function (_React$Component) {

  _inherits(GoogleChooser, _React$Component);

  function GoogleChooser(props) {
    _classCallCheck(this, GoogleChooser);

    var _this = _possibleConstructorReturn(
      this,
      (GoogleChooser.__proto__ || Object.getPrototypeOf(GoogleChooser)).call(
        this,
        props
      )
    );

    _this.onApiLoad = _this.onApiLoad.bind(_this);
    _this.onChoose = _this.onChoose.bind(_this);
    return _this;
  }
  _createClass(GoogleChooser, [
    {
      key: "componentWillReceiveProps",
      value: function componentWillReceiveProps(newProps) {
        //this.onChoose(newProps.token)
        this.props.token = newProps.token;
      }
    },
    {
      key: "componentDidMount",
      value: function componentDidMount() {
        if (this.isGoogleReady()) {
          // google api is already exists
          // init immediately
        } 
        else if (!scriptLoadingStarted) {
          // load google api and the init
          scriptLoadingStarted = true;
          (0, _loadScript2.default)(GOOGLE_SDK_API, this.onApiLoad);
        } 
        else {
          // is loading
        }
       
        this.onApiLoad();
      }
    },
    {
      key: "isGoogleReady",
      value: function isGoogleReady() {
        return !!window.gapi;
      }
    },
    {
      key: "isGoogleAuthReady",
      value: function isGoogleAuthReady() {
        console.log("isGoogleAuthReady",window.google)
        if(window.google&&window.google.accounts)
        return !!window.google.accounts;
      }
    },
    {
      key: "isGooglePickerReady",
      value: function isGooglePickerReady() {
        return !!window.google.picker;
      }
    },
    {
      key: "onApiLoad",
      value: function onApiLoad() {
        var _this = this;
        window.gapi.load("picker", {
          callback: function () {
            !_this.props.connect ? _this.onChoose() : null;
          }
        });
      }
    },
    {
      key: "doAuth",
      value: function doAuth(callback) {
        var state = JSON.stringify({"instance" : this.props.instance, "origCompId" : this.props.origCompId });
        var _this = this;
        var objArray = {};
        var obj = window.location.search.substr(1).split('&');
        for (var i = 0; i < obj.length; i++) {
          var descriptor = obj[i];
          descriptor = descriptor.split('=');
          objArray[descriptor[0]] = descriptor[1];
        }
        var state = JSON.stringify({"instance" : objArray.instance, "origCompId" : objArray.origCompId ,"compId": objArray.origCompId});
       const redirect_uri = window.location.protocol + "//" + window.location.host + "/api";
        // const redirect_uri = window.location.protocol + "//" + window.location.host + "/api";

        // const client = window.google.accounts.oauth2.initCodeClient({
        //   client_id: '1071120425870.apps.googleusercontent.com',
        //   scope: 'https://www.googleapis.com/auth/drive email profile',
        //   ux_mode: 'redirect',
        //   redirect_uri:redirect_uri,
        //   state:state,
        // });

       // client.requestCode();
         /////IMPORTANT !!! the login url in the window.open took from the auth url that generated by client.requestCode()
        window.open('https://accounts.google.com/o/oauth2/v2/auth?gsiwebsdk=3&client_id='+_this.props.clientId+'&scope=https%3A%2F%2Fwww.googleapis.com%2Fauth%2Fdrive.file%20email%20profile&redirect_uri='+redirect_uri+'&prompt=consent&state='+state+'&access_type=offline&response_type=code&include_granted_scopes=false&enable_granular_consent=true','Google login','toolbar=yes,scrollbars=yes,resizable=yes,top=500,left=500,width=500,height=600, fullscreen=no')
      }
    },
    {
      key: "onChoose",
      value: function onChoose(token) {
        console.log('onChoose token',this.props.connect,this.props.token,token)
        if (
          !this.isGoogleReady() ||
          !this.isGoogleAuthReady() ||
          !this.isGooglePickerReady() ||
          this.props.disabled
        ) {
          return null;
        }
       const oauthToken = token ? token : this.props.token;
        if (oauthToken && !this.props.connect) {
          this.createPicker(oauthToken);
        } else if(this.props.connect){
          this.doAuth(function (_ref) {
          });
        }
      }
    },
    {
      key: "createPicker",
      value: function createPicker(oauthToken) {
        console.log("createPicker",oauthToken)
        this.props.onAuthenticate(oauthToken);

        if (this.props.createPicker) {
          return this.props.createPicker(window.google, oauthToken);
        }

        var googleViewId = window.google.picker.ViewId[this.props.viewId];
        var view = new window.google.picker.View(googleViewId);

        if (this.props.mimeTypes) {
          view.setMimeTypes(this.props.mimeTypes.join(","));
        }

        if (!view) {
          throw new Error("Can't find view by viewId");
        }

        var picker = new window.google.picker.PickerBuilder()
          .addView(view)
          .setOAuthToken(oauthToken)
          .setDeveloperKey(process.env.REACT_APP_KEY)
          .setAppId(process.env.REACT_APP_ID)
          .setCallback(this.props.onChange);

        if (this.props.origin) {
          picker.setOrigin(this.props.origin);
        }

        if (this.props.navHidden) {
          picker.enableFeature(window.google.picker.Feature.NAV_HIDDEN);
        }

        if (this.props.multiselect) {
          picker.enableFeature(
            window.google.picker.Feature.MULTISELECT_ENABLED
          );
        }

        picker.build().setVisible(true);
      }
    },
    {
      key: "render",
      value: function render() {
        if (this.props.connect) {
          return _react2.default.createElement(
            "div",
            { onClick: this.onChoose },
            this.props.children
              ? this.props.children
              : _react2.default.createElement(
                "button",
                { id: "button1" },
                "Open google chooser"
              )
          );
        } else {
          return null;
        }
      }
    }
  ]);

  return GoogleChooser;
})(_react2.default.Component);

GoogleChooser.propTypes = {
  children: _propTypes2.default.node,
  clientId: _propTypes2.default.string.isRequired,
  developerKey: _propTypes2.default.string,
  scope: _propTypes2.default.array,
  viewId: _propTypes2.default.string,
  authImmediate: _propTypes2.default.bool,
  origin: _propTypes2.default.string,
  onChange: _propTypes2.default.func,
  onAuthenticate: _propTypes2.default.func,
  createPicker: _propTypes2.default.func,
  multiselect: _propTypes2.default.bool,
  navHidden: _propTypes2.default.bool,
  disabled: _propTypes2.default.bool
};
GoogleChooser.defaultProps = {
  onChange: function onChange() { },
  onAuthenticate: function onAuthenticate() { },
  scope: ["https://www.googleapis.com/auth/drive.file"],
  viewId: "DOCS",
  authImmediate: false,
  multiselect: false,
  navHidden: false,
  disabled: false
};
exports.default = GoogleChooser;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-google-picker/dist/react-google-picker.js
// module id = 412
// module chunks = 0 1